export const MY_GOAL = '/my-team';
export const CATFISH = '/rest/ads/list/catfish';

export const TWITTER = 'https://twitter.com/Golrusuper';
export const VK = 'https://vk.com/gol_ru';
export const TG = 'https://tele.click/coolgol';
